import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nationalMemberField", "prefixSelect", "nationalMemberInput"]

  connect() {
    this.update()
  }

  update() {
    const showNationalMemberField = this.prefixSelectTarget.value === "+61"

    this.nationalMemberFieldTarget.classList.toggle("hidden", !showNationalMemberField)

    if (!showNationalMemberField) {
      this.nationalMemberInputTarget.value = ""
    }
  }
}
